import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { DOCTOR_KOBO_FORM } from 'src/app/constant/constant';
import { ZoomService } from 'src/app/services/zoom.service';
import { TraceClassDecorator } from '@sentry/angular';

@Component({
    selector: 'app-novspecial-doctordashboard',
    templateUrl: './novspecial-doctordashboard.component.html',
    styleUrls: [
        './novspecial-doctordashboard.component.css',
        './../../../../../assets/css/custom-egd-1.css'
    ]
})
@TraceClassDecorator()
export class NovspecialDoctordashboardComponent implements OnInit {
    @Input('is_doctor')
    is_doctor: boolean = false;
    url_link: string = '';

    weekdays: string[][] = [
        ['6:00AM', '10:30AM'],
        ['5:30PM', '8:30PM']
    ];
    weekends: string[][] = [
        ['6:00AM', '10:30AM'],
        ['5:30PM', '9:30PM']
    ];
    form_link: string = DOCTOR_KOBO_FORM;
    response_success = null;
    constructor(
        public zoomService: ZoomService,
    ) {}

    async ngOnInit(): Promise<void> {
        await this.getSpecialLinkandTimings();
    }
    async getSpecialLinkandTimings() {
        await this.zoomService
            .GetSpecialZoomLink()
            .toPromise()
            .then((result) => {
                if (result.success) {
                    this.response_success = result.success;
                    //Patient Link
                    if (this.is_doctor != null && !this.is_doctor) {
                        this.url_link = result.data.link;
                        //weekdays is at 0
                        this.weekdays = result.data.timings[0];
                        //weekdays is at 1
                        this.weekends = result.data.timings[1];
                    }
                }
            });
    }
    openZoomLink() {
        window.open(this.url_link, '_blank');
    }

    open_form() {
        window.open(this.form_link, '_blank');
    }

    getBoolean(value: any): boolean {
        return Boolean(value);
    }
}
